/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 ${ORGANIZATION}.
 * @license    __LICENSE__
 */

$(() => {
  // prepare rowItem
  const rowAnimation = $('.j-row-animation');

  rowAnimation.each(function (i, e) {
    const row = $(e).children();

    row.each(function (i, e) {
      $(e).addClass('c-animation-item');
    });
  });

  //scroll Event
  $(window).on('scroll', function () {
    const animationLeft = $('.j-animation-left');
    const animationUp = $('.j-animation-up');
    const animationRight = $('.j-animation-right');
    const rowAnimation = $('.j-row-animation');

    animationUp.each(function (i, e) {
      fadeInAnimation(e, 'btt c-animation');
    });

    animationLeft.each(function (i, e) {
      fadeInAnimation(e, 'ltr c-animation');
    });

    animationRight.each(function (i, e) {
      fadeInAnimation(e, 'rtl c-animation');
    });

    rowAnimation.each(function (i, e) {
      const row = $(e);
      const firstColumn = row.children('div :nth-child(3n+1)');
      const secondColumn = row.children('div :nth-child(3n+2)');
      const thirdColumn = row.children('div :nth-child(3n)');

      firstColumn.each(function (i, e) {
        fadeInAnimation(e, 'ltr c-animation');
      });

      secondColumn.each(function (i, e) {
        fadeInAnimation(e, 'btt c-animation');
      });

      thirdColumn.each(function (i, e) {
        fadeInAnimation(e, 'rtl c-animation');
      });
    });
  });

  function fadeInAnimation(el, c) {
    let target = $(el);

    if (isElementInViewport(target)) {
      if (!target.hasClass(c)) {
        target.addClass(c);
      }
    }
  }

  function isElementInViewport(el) {
    var rect = el[0].getBoundingClientRect();

    return (
      window.innerHeight - rect.top > 100
    );
  }
});
